export default defineNuxtRouteMiddleware(() => {
  const { loaders } = useLoader();
  if (loaders.payment)
  { loaders.payment = false; }
});
